import { useRef } from "react";
import { styled } from "styled-components";
import BlurScreen from "../BlurScreen";

const ProgressBar = styled.div`
    height: 20px;
    position: relative;
    width: 65%;
    border-radius: 10px;

    --bar-progress: 0%;

    &::after {
        width: var(--bar-progress);
        height: 100%;
        background-color: var(--d8s-progress);	        
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 10px;
    }
`;

const Label = styled.label`
    font-size: 20px;
    font-weight: 500;
`;

const LoadProgressInfo = ({ progress, isReady }) => {
	const { loaded, total } = progress;
	const barRef = useRef(null);
	const labelRef = useRef(null);
	const percent =  total ? ((loaded / total) * 100 ): 0;
	const isActive = percent > 0 && percent < 100;
	const status = percent === 0 ? "Preparing Viewer" : (isActive ? "Loading Model" : "Finalizing");

	//TODO: really ugly but without accessing the dom directly, react doesnt update the dom fast enough to show the progress
	if (barRef.current) {
		barRef.current.style.setProperty("--bar-progress", `${percent}%`);
	}

	//TODO: same
	if (labelRef.current){
		labelRef.current.innerText = status;
	}

	return (!isReady &&
		<BlurScreen>
			<Label ref={labelRef}>{status}</Label>
			<ProgressBar ref={barRef} />
		</BlurScreen>
	);
};

export default LoadProgressInfo;
